module.exports = __webpack_public_path__ + "img/levels-of-detail.zh_tw.43775682.png";